import { Divider } from './Divider'
import { Root } from './Root'
import { Section } from './Section'

export const layout = {
  Root,
  Section,
  Divider,
}
